import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const usePlanItMechanicsQuery = (dealerLocationIds?: number[]) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.planItMechanics,
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: (dealerLocationIds && dealerLocationIds[0]) ?? 0 }, baseUrl)).data.planit_planning_mechanics,
    enabled: !!dealerLocationIds && dealerLocationIds.length > 1
  });
